
<style  scoped>
.cart {
  min-height: calc(100vh - 100px);
  background-color: #f2f2f2 !important;
}
.van-submit-bar {
  bottom: 50px;
}
.van-submit-bar >>> .van-submit-bar__button--danger {
  background: #ffc053;
}
.list-box {
  padding-bottom: 150px;
}
.list-item {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #f3f3f3;
  /* margin: 5px; */
  border-radius: 10px;
}
.van-card {
  background-color: #fff;
  padding: 10px 0;
}
.list-item >>> div:nth-child(1) {
  flex: 1;
}
.check-box >>> .van-icon {
  margin: auto;
}
.list-item >>> div:nth-child(2) {
  flex: 4;
}
.list-item >>> div:nth-child(3) {
  flex: 2;
}
.van-stepper {
  text-align: center;
}
.van-card__price {
  color: red;
  font-size: 16px;
}
.van-card__price-integer {
  font-size: 20px;
}
.van-card >>> .van-ellipsis {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: visible;
  line-height: 14px;
  font-size: 14px;
}
.van-card__content >>> div:nth-child(1) {
  flex: 3;
}
.van-card__content >>> div:nth-child(2) {
  flex: 1.5;
}
.van-card__content >>> .van-card__title {
  font-size: 16px;
}
.delete {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.swipe-button {
  height: 100%;
}
.van-submit-bar__bar >>> .van-button__text {
  color: black;
}
.tip-box {
  width: 100%;
  background: #fff;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
}
.tip-num,
.tip-price {
  color: red;
  font-size: 16px;
}
.van-submit-bar >>> .tip-num,
.van-submit-bar >>> .tip-price {
  color: #fff;
  font-size: 16px;
  padding: 0 2px;
}
.tip-btn {
  padding: 2px 5px;
}
.pop-cell {
  margin-top: 50px;
  height: 100%;
  overflow: scroll;
}
.tip-value {
  display: inline-block;
  background: red;
  color: #fff;
  border-radius: 5px;
  padding: 0px 10px;
  font-size: 12px;
  margin-left: 5px;
}
.tip-title {
  font-weight: 500;
  font-size: 16px;
}
.pop-bottom-btn {
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
.cell-box {
  max-height: 100vh;
  overflow: scroll;
}
.pop-btn-add,
.pop-btn-turn {
  flex: 1;
  color: black !important;
}
.van-coupon-list >>> .van-tab:nth-child(2) {
  display: none;
}
.van-submit-bar__tip {
  background-color: #3ba26e;
  color: #fff;
  font-size: 14px;
}
.pop-cell >>> .van-cell__value {
  flex: 0.5;
}
.red {
  color: red;
  font-size: 14px;
  font-weight: normal;
  padding: 2px;
}
.van-cell__label {
  font-size: 14px;
  color: #3ba26e;
}
</style>


<template>
  <div class="cart">
    <div v-if="!showPage">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>

    <div v-else>
      <van-empty
        v-if="!list.length>0"
        class="custom-image"
        :image="require('../../assets/icons/empty.png')"
        description="购物车是空的..."
      />

      <div class="list-box">
        <van-swipe-cell v-for="(item,index) in list" :key="index">
          <div class="list-item">
            <div class="check-box">
              <van-checkbox
                checked-color="#ffc053"
                v-model="item.IsChecked"
                ref="checkbox"
                @click="toChecked(item.id,index)"
              />
            </div>

            <van-card
              :price="(item.Price/100).toFixed(2)"
              :desc="`${item.OptionWeight}${item.OptionUnit}`"
              :title="item.OptionName"
              :thumb="item.OptionImage"
              @click="toProduct(item.ItemId)"
            >
              <template #desc>
                <span>{{item.OptionWeight}}{{item.OptionUnit}}</span>
                <br />
                <span>库存:{{item.Stock}}</span>
              </template>

              <template #footer v-if="item.NextCoupon&&item.NextCoupon.Num&&item.NextCoupon.Num>0">
                <div class="tip-box" @click.stop="addCouponsNum(item.id,item.NextCoupon.Num,index)">
                  <span>
                    差
                    <span class="tip-num">{{item.NextCoupon.Num-item.Num}}</span> 件即可优惠
                    <span class="tip-price">{{item.NextCoupon.Total/100}}</span> 元
                  </span>
                  <van-button class="tip-btn" size="mini" color="red" type="primary">添加</van-button>
                </div>
              </template>
              <template
                #footer
                v-else-if="item.UsedCoupon&&item.UsedCoupon.Num&&item.UsedCoupon.Num>0"
              >
                <div class="tip-box" @click.stop="addCouponsNum(item.id)">
                  <span>
                    已满
                    <span class="tip-num">{{item.UsedCoupon.Num}}</span>件 优惠
                    <span class="tip-price">{{item.UsedCoupon.Total/100}}</span>元
                  </span>
                </div>
              </template>
            </van-card>
            <van-stepper
              v-model="item.Num"
              :max="item.Max"
              async-change
              disable-input
              @plus="plus(item.id,index)"
              @minus="minus(item.id,index)"
            />
          </div>
          <template #right>
            <van-button
              class="swipe-button"
              @click="collect(item.id)"
              square
              type="primary"
              text="收藏"
            />
            <van-button
              class="swipe-button"
              @click="toDelete(item.id,index)"
              square
              type="danger"
              text="删除"
            />
          </template>
        </van-swipe-cell>
      </div>

      <van-submit-bar :price="total" button-text="提交订单" :disabled="!total>0" @submit="onSubmit">
        <van-checkbox @click="checkAllOption" checked-color="#ffc053" v-model="checkedAll">全选</van-checkbox>
        <template #tip v-if="UsedStoreTotal>0||UsedFYFTotal>0">
          <div>
            已使用单品卷优惠
            <strong class="tip-num">{{UsedStoreTotal/100}}</strong>元、平台红包优惠
            <strong class="tip-price">{{UsedFYFTotal/100}}</strong>元
          </div>
        </template>
      </van-submit-bar>
    </div>

    <van-popup
      v-model="show"
      lock-scroll
      closeable
      round
      position="bottom"
      :style="{ minHeight: '50%' }"
    >
      <div class="cell-box">
        <van-cell-group class="pop-cell">
          <van-cell>
            <template #title>
              <div class="tip-title">
                <van-icon name="discount" />单品卷
                <span class="tip-value">可减{{StoreTotal/100}}元</span>
              </div>
            </template>
            <template #label>
              <div v-for="(item,index) in checkedList" :key="index">
                <div v-if="item.NextCouponStore.Num>0">
                  {{item.OptionName}}{{item.OptionWeight}}{{item.OptionUnit}}
                  <br />
                  {{item.NextCouponStore.CouponName}} 满
                  <strong
                    class="red"
                  >{{item.NextCouponStore.Num}}</strong>包减
                  <strong class="red">{{item.NextCouponStore.Total/100}}</strong>元
                </div>
              </div>
            </template>
            <!-- <template #default>
            <span class="tip-value">可减{{StoreTotal/100}}元</span>
            </template>-->
          </van-cell>
          <van-cell>
            <template #title>
              <div class="tip-title">
                <van-icon name="cash-on-deliver" />平台红包
                <span class="tip-value">可减{{YFYTotal/100}}元</span>
              </div>
            </template>

            <template #label>
              <div v-for="(item,index) in checkedList" :key="index">
                <div v-if="item.NextCouponYFY.Num>0">
                  {{item.OptionName}}{{item.OptionWeight}}{{item.OptionUnit}}
                  <br />
                  {{item.NextCouponYFY.CouponName}} 满
                  <strong class="red">{{item.NextCouponYFY.Num}}</strong>包减
                  <strong class="red">{{item.NextCouponYFY.Total/100}}</strong>元
                </div>
              </div>
            </template>
            <!-- <template #default>
            <span class="tip-value">可减{{YFYTotal/100}}元</span>
            </template>-->
          </van-cell>
          <!-- <van-cell title="用券后" value="总计：2000">
          <template>
            合计：<strong class="red">￥{{nextTotal/100}}</strong>
          </template>
          </van-cell>-->
        </van-cell-group>
      </div>

      <div class="pop-bottom-btn">
        <van-button
          type="primary"
          color="#ffc053"
          @click="addCouponNextAll"
          class="pop-btn-add"
        >一键添加</van-button>
        <van-button type="default" class="pop-btn-turn" @click="toDetail">直接提交</van-button>
      </div>
    </van-popup>

    <!-- 商品卷列表 -->
    <!-- <van-popup
      v-model="showCoupons"
      lock-scroll
      closeable
      round
      position="bottom"
      :style="{ minHeight: '50%' }"
    >
      <van-coupon-list
        :show-exchange-bar="false"
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        @change="onChange"
        @exchange="onExchange"
        enabled-title="单品卷"
        :show-count="false"
      />
    </van-popup>-->

    <!-- 平台红包列表 -->
    <!-- <van-popup
      v-model="showRedPacket"
      lock-scroll
      closeable
      round
      position="bottom"
      :style="{ minHeight: '50%' }"
    ></van-popup>-->
  </div>
</template>

<script>
// const coupon = {
//   available: 1,
//   condition: "无使用门槛\n最多优惠12元",
//   reason: "",
//   value: 150,
//   name: "优惠券名称",
//   startAt: 1489104000,
//   endAt: 1514592000,
//   valueDesc: "1.5",
//   unitDesc: "元"
// };

import api from "../../api/cart";
import {
  SubmitBar,
  Checkbox,
  CheckboxGroup,
  Empty,
  Icon,
  Card,
  Stepper,
  SwipeCell,
  Popup,
  CouponList,
  CouponCell,
  Cell,
  CellGroup,
  Button
} from "vant";
let vm = this;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    [SubmitBar.name]: SubmitBar,
    [Checkbox.name]: Checkbox,
    [Empty.name]: Empty,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Stepper.name]: Stepper,
    [CheckboxGroup.name]: CheckboxGroup,
    [SwipeCell.name]: SwipeCell,
    [Popup.name]: Popup,
    [CouponList.name]: CouponList,
    [CouponCell.name]: CouponCell,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button
  },
  data() {
    //这里存放数据
    return {
      checkedAll: false,
      list: [],
      showPage: false,
      showCoupons: false,
      showRedPacket: false,
      total: 0,
      // coupons: [coupon],
      checkedList: [],
      StoreTotal: 0,
      YFYTotal: 0,
      UsedStoreTotal: 0,
      UsedYFYTotal: 0,
      nextTotal: 0,
      show: false
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  //方法集合
  methods: {
    //   直接进入详情页
    toDetail() {
      this.$router.push({
        path: "/cartDetail"
      });
    },
    // 一键添加 更高一级优惠券 成功后 跳转详情页
    addCouponNextAll() {
      let checkedList = this.checkedList;
      let promise = [];
      checkedList.forEach((item, i) => {
        let Num =
          item.NextCouponStore.Num > item.NextCouponYFY.Num
            ? item.NextCouponStore.Num
            : item.NextCouponYFY.Num;
        if (Num > 0) {
          let add = api
            .cartItemUpdate(`cartItemUpdate?id=${item.id}`, { Num })
            .then(res => {
              this.setCartItem(i, res);
            });
          promise.push(add);
        }
      });

      promise.length > 0
        ? Promise.all(promise).then(values => {
            this.$router.push({
              path: "/cartDetail"
            });
          })
        : "";
    },

    toChecked(id, index) {
      console.log(id, index);
      let oldStatus = !this.list[index].IsChecked;
      let Status = this.list[index].IsChecked ? 1 : 0;
      console.log("newStatus", this.list[index].IsChecked);
      api
        .cartItemUpdate(`cartItemUpdate?id=${id}`, { Status })
        .then(res => {
          if (res.status == 0) {
            // if (!oldStatus) {
            //   this.list[index].Status = 1;
            // } else {
            //   this.list[index].Status = 0;
            // }
            this.setCartItem(index, res);
          } else {
            this.$toast.fail(res.message);
            this.list[index].IsChecked = oldStatus;
          }
          this.getTotal();
        })
        .catch(() => {
          this.$toast.fail(res.message);
          this.list[index].IsChecked = oldStatus;
        });
    },

    // card 添加满足优惠券数量
    addCouponsNum(id, Num, index) {
      let i = index;
      api.cartItemUpdate(`cartItemUpdate?id=${id}`, { Num }).then(res => {
        this.setCartItem(i, res);
      });
    },

    checkAllOption(e) {
      let that = this;
      let list = that.list;
      let promise = [];
      list.forEach((item, i) => {
        // that.$refs.checkbox[i].IsChecked=true

        if (this.checkedAll) {
          if (item.Status == 0) {
            let a = api
              .cartItemUpdate(`cartItemUpdate?id=${item.id}`, { Status: 1 })
              .then(res => {
                this.setCartItem(i, res);
                this.$set(this.list, i, that.list[i]);
              });
            promise.push(a);
          }
        } else {
          if (item.Status == 1) {
            let b = api
              .cartItemUpdate(`cartItemUpdate?id=${item.id}`, { Status: 0 })
              .then(res => {
                this.setCartItem(i, res);
                this.$set(this.list, i, that.list[i]);
              });
            promise.push(b);
          }
        }
      });

      Promise.all(promise).then(values => {
        this.getTotal();
      });
    },

    setCartItem(i, res) {
      this.list[i] = res.result;
      this.list[i].IsChecked = res.result.Status == 1 ? true : false;
      this.CouponsTotalStore = res.CouponsTotalStore;
      this.CouponsTotalYFY = res.CouponsTotalYFY;
      this.$set(this.list, i, this.list[i]);
      let UsedStoreTotal = 0;
      let UsedFYFTotal = 0;
      this.list.forEach(item => {
        UsedStoreTotal +=
          item.Status == 1 && item.UsedCouponStore.Total > 0
            ? item.UsedCouponStore.Total
            : 0;
        UsedFYFTotal +=
          item.Status == 1 && item.UsedCouponYFY.Total > 0
            ? item.UsedCouponYFY.Total
            : 0;
      });
      this.UsedStoreTotal = UsedStoreTotal;
      this.UsedFYFTotal = UsedFYFTotal;
    },

    plus(id, index) {
      let newNum = this.list[index].Num;
      this.list[index].Num -= 1;
      console.log(newNum, id, index);
      //    发送请求  通过后+1 不通过 原值
      api
        .cartItemUpdate(`cartItemUpdate?id=${id}`, {
          Num: newNum
        })
        .then(res => {
          if (res.status == 0) {
            if (res.message == "库存不足") {
              this.getTotal();
              return this.$toast.fail(res.message);
            }
            this.setCartItem(index, res);
          } else {
            this.$toast.fail("操作失败");
          }
          this.getTotal();
        });
    },
    minus(id, index) {
      let newNum = this.list[index].Num;
      this.list[index].Num += 1;
      console.log(newNum, id, index);
      //    发送请求  通过后-1 不通过 原值
      api
        .cartItemUpdate(`cartItemUpdate?id=${id}`, {
          Num: newNum
        })
        .then(res => {
          if (res.status == 0) {
            this.setCartItem(index, res);
          } else {
            this.$toast.fail("操作失败");
          }
          this.getTotal();
        });
    },
    toDelete(id, index) {
      console.log(id, index);
      //   发送请求 成功 删除
      api
        .cartItemUpdate(`cartItemUpdate?id=${id}`, {
          Status: -1
        })
        .then(res => {
          if (res.status == 0) {
            this.list.splice(index, 1);
            this.CouponsTotalStore = res.CouponsTotalStore;
            this.CouponsTotalYFY = res.CouponsTotalYFY;
            this.getTotal();
          } else {
            this.$toast.fail("操作失败");
          }
          this.getTotal();
        });
    },
    collect(id) {
      console.log(id);
      this.$toast("收藏成功");
    },
    //   提交订单
    onSubmit() {
      this.StoreTotal = 0;
      this.YFYTotal = 0;
      this.checkedList = this.list.filter(item => {
        item.NextCouponStore?this.StoreTotal += item.NextCouponStore.Total:'';
        item.NextCouponYFY?this.YFYTotal += item.NextCouponYFY.Total:'';
        // this.nextTotal= item.Num*item.Price-item.NextCouponYFY.Total-item.NextCouponStore.Total
        return item.IsChecked;
      });
      console.log(this.checkedList);
      // this.show = true
      this.StoreTotal > 0 || this.YFYTotal > 0
        ? (this.show = true)
        : this.toDetail();
    },
    //   更新总价
    getTotal() {
      let total = 0;
      this.list.forEach(item => {
        total += item.Price * item.Num * item.IsChecked;
        console.log(item.IsChecked);
      });
      this.total = total - this.CouponsTotalStore - this.CouponsTotalYFY;
    },
    // 商品页面跳转
    toProduct(id) {
      this.$router.push({
        path: "/product",
        query: {
          id: id
        }
      });
    },
    init() {
      // 购物车列表
      api.cartItemList().then(res => {
        if (res.status == 0) {
          this.list = res.result;
          this.CouponsTotalStore = res.CouponsTotalStore;
          this.CouponsTotalYFY = res.CouponsTotalYFY;
          this.checkedAll = false;

          let UsedStoreTotal = 0;
          let UsedFYFTotal = 0;
          res.result.forEach(item => {
            item.IsChecked = item.Status == 1 ? true : false;
            this.checkedAll = item.Status == 0 ? false : true;

            UsedStoreTotal +=
              item.Status == 1 && item.UsedCouponStore.Total > 0
                ? item.UsedCouponStore.Total
                : 0;
            UsedFYFTotal +=
              item.Status == 1 && item.UsedCouponYFY.Total > 0
                ? item.UsedCouponYFY.Total
                : 0;
          });
          this.UsedStoreTotal = UsedStoreTotal;
          this.UsedFYFTotal = UsedFYFTotal;
          this.getTotal();
          this.showPage = true;
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getTotal();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
